"use client";

import {
  buildEmployerAbility,
  checkEmployerPermission,
  type EmployerAbilityInstance,
  type EmployerAbilityRecord,
  type Subject,
  type SubjectActions,
} from "@/server/models/employer-office/employer-ability";
import { createContext, useContext, useMemo, type ReactNode } from "react";

const EmployerPermissionContext = createContext<EmployerAbilityInstance | null>(
  null,
);

export const EmployerPermissionProvider = ({
  children,
  abilities,
}: {
  children: ReactNode;
  abilities: ReadonlyArray<EmployerAbilityRecord>;
}) => {
  const ability = useMemo(() => buildEmployerAbility(abilities), [abilities]);

  return (
    <EmployerPermissionContext.Provider value={ability}>
      {children}
    </EmployerPermissionContext.Provider>
  );
};

export const useEmployerPermission = () => {
  const ability = useContext(EmployerPermissionContext);
  if (!ability) {
    return {
      checkEmployerPermission: () => false,
    };
  }
  return {
    checkEmployerPermission: <Sub extends Subject>(
      subject: Sub,
      action: SubjectActions<Sub>,
    ) => checkEmployerPermission(ability, subject, action),
  };
};
